import { useRoute } from '#app'

import { getBlogCategory } from '@/utils/blog.js'
import blogEntries from '@/preload/data/blogEntries.json'

export default function () {
  const route = useRoute()
  const blogCategory = getBlogCategory()

  return {
    isBlogPage: blogCategory && blogCategory.path === route.path,
    blogEntries,
    blogCategory,
  }
}
